<!--
 * @Description: 
 * @Author: pcc
 * @Date: 2022-12-29 17:18:10
 * @LastEditors: xie
 * @LastEditTime: 2024-07-31 15:36:50
-->
<template>
  <div id="app">
    <pc-layout-one v-if="$templates() === 'themeTemplateOne'"></pc-layout-one>
    <pc-layout-tow v-else-if="$templates() === 'themeTemplateTwo'"></pc-layout-tow>
    <pc-layout-three v-else-if="$templates() === 'themeTemplateThree'"></pc-layout-three>
    <pc-layout-four v-else-if="$templates() === 'themeTemplateFour'"></pc-layout-four>
    <pc-layout-five v-else-if="$templates() === 'themeTemplateFive'"></pc-layout-five>
    <pc-layout-six v-else-if="$templates() === 'themeTemplateSix'"></pc-layout-six>
    <pc-layout-seven v-else-if="$templates() === 'themeTemplateSeven'"></pc-layout-seven>
    <pc-layout-eight v-else-if="$templates() === 'themeTemplateEight'"></pc-layout-eight>
    <pc-layout-nine v-else-if="$templates() === 'themeTemplateNine'"></pc-layout-nine>
    <pc-layout-ten v-else-if="$templates() === 'themeTemplateTen'"></pc-layout-ten>
  </div>
</template>

<script>
import { ipView } from '@/api/statistics'
import { getCartListApi } from '@/api/cart'
import { SiteSettingWebGetInfo } from '@/api/home'
import { mapActions, mapGetters, mapState } from 'vuex'
import { setDocumentTitle } from '@/utils/domUtil'
import mixins from '@/utils/mixins'
export default {
  name: 'App',
  mixins: [mixins],
  components: {
    pcLayoutOne: () => import('@/components/themeTemplateOne/index.vue'),
    pcLayoutTow: () => import('@/components/themeTemplateTwo/index.vue'),
    pcLayoutThree: () => import('@/components/themeTemplateThree/index.vue'),
    pcLayoutFour: () => import('@/components/themeTemplateFour/index.vue'),
    pcLayoutFive: () => import('@/components/themeTemplateFive/index.vue'),
    pcLayoutSix: () => import('@/components/themeTemplateSix/index.vue'),
    pcLayoutSeven: () => import('@/components/themeTemplateSeven/index.vue'),
    pcLayoutEight: () => import('@/components/themeTemplateEight/index.vue'),
    pcLayoutNine: () => import('@/components/themeTemplateNine/index.vue'),
    pcLayoutTen: () => import('@/components/themeTemplateTen/index.vue')
  },
  data() {
    return {}
  },
  computed: {
    ...mapState('user', {
      token: state => state.token
    }),
    ...mapGetters('user', {
      userInfo: 'get_userInfo'
    })
  },
  created() {
    ipView({ source: 2 }).then(res => {
      console.log(res)
    })
    if (this.userInfo && this.token !== '') {
      getCartListApi({
        userId: this.userInfo.id
      }).then(res => {
        if (res.success) {
          this.setCart(res.data)
        }
      })
    }

    SiteSettingWebGetInfo()
      .then(res => {
        if (res.success) {
          this.setSetting(res.data)
          if (res.data === 'en') {
            setDocumentTitle(res.data.enTitle)
          } else if (res.data === 'ru') {
            setDocumentTitle(res.data.rusTitle)
          } else {
            setDocumentTitle(res.data.title)
          }
        } else {
          this.$message(res.message)
        }
      })
      .catch(err => {
        this.$message({ err })
      })
  },
  methods: {
    ...mapActions('operate', {
      setCart: 'set_cart'
    }),
    ...mapActions('setting', {
      setSetting: 'set_setting'
    })
  }
}
</script>

<style lang="scss">
body,
dl,
dt,
dd,
h3,
p {
  margin: 0;
  padding: 0;
}

.container {
  margin: 0 auto;

  & ul,
  li {
    margin: 0;
    padding: 0;
    list-style: none;
  }
}
</style>
